export default __webpack_public_path__ + "static/media/mobile.fe237b43.svg";